
    import has from 'lodash/has';
    import { mapState, mapActions, mapMutations } from 'vuex';
    import { ValidationObserver } from 'vee-validate';
    import ApplyMixin from '@/components/JobView/Apply/ApplyMixin';
    import SeekerLocations from '@/components/Seeker/SeekerLocations';
    import SeekerOccupations from '@/components/Seeker/SeekerOccupations';
    import SeekerAttributesTypeahead from '@/components/Seeker/SeekerAttributesTypeahead';
    import SeekerRecentRoleCombo from '@/components/Seeker/SeekerRecentRoleCombo';
    import ApplyThankYou from '@/components/JobView/Apply/ApplyThankYou';
    import { jobData } from '@/utils/jobData';
    import datalayer from '@/utils/datalayer';
    import C1Spinner from '@/C1Components/C1Spinner';

    export default {
        name: 'ApplyOnboardingQuestions',

        components: {
            ValidationObserver,
            SeekerLocations,
            SeekerOccupations,
            SeekerAttributesTypeahead,
            SeekerRecentRoleCombo,
            ApplyThankYou,
            C1Spinner,
        },

        mixins: [ApplyMixin],

        data() {
            return {
                lookingForAJob: false,
                isSeekerRecentRoleComboInitializing: false,
                spinner: {
                    work_experience: false,
                    update_me: false,
                },
            };
        },

        computed: {
            ...mapState({
                $_jobApplication: state => state.jobApplication,
            }),
        },

        created() {
            this.$_STORE_APPLY_STEP(2);

            const data = {
                event: 'light_onboarding_start',
            };

            this.$_pushEvent({
                ...data,
                ...jobData(this.$_job),
            });

            datalayer(data);
        },

        mounted() {
            if (process.browser) {
                this.$velocity(document.getElementById('jvApply'),
                               'scroll',
                               {
                                   duration: 600,
                               });
            }
        },

        methods: {
            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            ...mapActions('me', {
                $_updateMyDetails: 'updateMyDetails',
                $_storeWorkExperience: 'storeWorkExperience',
                $_updateWorkExperience: 'updateWorkExperience',
            }),

            ...mapMutations('jobApplication', {
                $_STORE_APPLY_STEP: 'STORE_APPLY_STEP',
            }),

            toggleSeekerNewbie(islookingForAJob) {
                this.lookingForAJob = islookingForAJob;
                const data = {
                    career_level_opt_id: islookingForAJob ? 51 : '',
                };
                this.$_updateMyDetails(data);
            },

            async saveWorkExperience() {
                const validator = await this.$refs.formOnboarding.validate();
                if (!validator) {
                    return false;
                }

                const seekerRecentRoleCombo = this.$refs.seekerRecentRoleCombo;

                if (typeof seekerRecentRoleCombo === 'undefined') {
                    this.finishOnboardingQuestions();

                    return;
                }

                const data = {
                    job_title: has(seekerRecentRoleCombo.jobTitle, 'label') ? seekerRecentRoleCombo.jobTitle.label : '',
                    occupation_id: has(seekerRecentRoleCombo, 'occupation.occupations[0].id') ? seekerRecentRoleCombo.occupation.occupations[0].id : '',
                };

                if (!has(seekerRecentRoleCombo, 'workExperience.id')) {
                    this.storeWorkExperience(data);
                } else {
                    this.updateWorkExperience(seekerRecentRoleCombo.workExperience.id, data);
                }
            },

            storeWorkExperience(data) {
                this.spinner.work_experience = true;
                this.$_storeWorkExperience(data).then(() => {
                    this.finishOnboardingQuestions();
                }).finally(() => {
                    this.spinner.work_experience = false;
                });
            },

            updateWorkExperience(id, data) {
                this.spinner.work_experience = true;
                this.$_updateWorkExperience({ workExperienceId: id, data }).then(() => {
                    this.finishOnboardingQuestions();
                }).finally(() => {
                    this.spinner.work_experience = false;
                });
            },

            finishOnboardingQuestions() {
                const data = {
                    profile_status: 'onboarded',
                };

                this.spinner.update_me = true;
                this.$_updateMyDetails(data).then(() => {
                    const data = {
                        event: 'light_onboarding_complete',
                    };

                    this.$_pushEvent({
                        ...data,
                        ...jobData(this.$_job),
                    });

                    datalayer(data);

                    this.$router.push({ name: 'discover' });
                }).catch(() => {
                    this.spinner.update_me = false;
                });
            },
        },
    };
